import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ProgressBar = ({ trainingProgram }) => {
    const theme = useTheme();
    const [progress, setProgress] = React.useState(0);

    React.useEffect(() => {
        if (!trainingProgram?.chapters) return;

        let totalScenarios = 0;
        let completedScenarios = 0;

        trainingProgram.chapters.forEach(chapter => {
            if (chapter?.scenarios) {
                chapter.scenarios.forEach(scenario => {
                    if (scenario) {
                        totalScenarios += 1;
                        if (scenario.completed) {
                            completedScenarios += 1;
                        }
                    }
                });
            }
        });

        const percentage = totalScenarios > 0 ? (completedScenarios / totalScenarios) * 100 : 0;
        setProgress(percentage);
    }, [trainingProgram]);

    return (
        <Box>
            <Typography sx={{
                fontWeight: theme.typography.fontWeightMedium,
                fontSize: theme.typography.textXS.fontSize,
                lineHeight: theme.typography.textXS.lineHeight,
            }}>
                PROGRAM PROGRESS
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", mt: theme.customSpacing['lg'] }}>
                {/* Progress Bar */}
                <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 1 }}>
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        sx={{
                            flexGrow: 1,
                            height: 8,
                            borderRadius: theme.shape.borderRadius,
                            backgroundColor: theme.palette.background.brand_primary,
                            "& .MuiLinearProgress-bar": {
                                backgroundColor: theme.palette.border.brand,
                                borderRadius: theme.shape.borderRadius,
                            },
                        }}
                    />
                </Box>

                {/* Percentage Display */}
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: '100%',
                    mt: theme.customSpacing['md'],
                    mb: theme.customSpacing['md'],
                }}>
                    <Typography sx={{
                        fontSize: theme.typography.textXS.fontSize,
                        lineHeight: theme.typography.textXS.lineHeight,
                        fontWeight: theme.typography.fontWeightMedium,
                        color: '#BFBFCC',
                    }}>
                        {Math.round(progress)}% COMPLETED
                    </Typography>
                    <Typography>
                        🏆
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default ProgressBar;
